// extracted by mini-css-extract-plugin
module.exports = {"tagSidebar":"TagSidebar_tagSidebar__2mN-D","tagItem":"TagSidebar_tagItem__2T3yZ","tagIcon":"TagSidebar_tagIcon__1bYp4"};